import React from 'react';
import { FaUser, FaClipboardList, FaStickyNote, FaCheckCircle } from 'react-icons/fa';
import styles from './styles/ReservationPDF.module.css';

/**
 * Composant pour afficher la réservation (caché, utilisé pour générer le PDF)
 */
export default function ReservationPDF({ reservation, clientName, clientEmail }) {
    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('fr-FR', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };

    return (
        <div className={styles.pdfContainer}>
            <div className={styles.pdfContent}>
                {/* Header */}
                <div className={styles.header}>
                    <div className={styles.headerTop}>
                        <img
                            src="/images/logo.jpeg"
                            alt="OV Hairstyle Logo"
                            className={styles.logo}
                        />
                        <div className={styles.headerText}>
                            <h1>OV HAIRSTYLE</h1>
                            <p>Confirmation de Réservation</p>
                        </div>
                    </div>
                </div>

                {/* Contenu principal */}
                <div className={styles.mainContent}>
                    {/* Section Client */}
                    <div className={styles.section}>
                        <h2>
                            <FaUser className={styles.sectionIcon} />
                            Informations Client
                        </h2>
                        <div className={styles.infoBox}>
                            <div className={styles.infoLine}>
                                <span className={styles.infoLabel}>Nom:</span>
                                <span className={styles.infoValue}>{clientName}</span>
                            </div>
                            <div className={styles.infoLine}>
                                <span className={styles.infoLabel}>Email:</span>
                                <span className={styles.infoValue}>{clientEmail}</span>
                            </div>
                        </div>
                    </div>

                    {/* Section Réservation */}
                    <div className={styles.section}>
                        <h2>
                            <FaClipboardList className={styles.sectionIcon} />
                            Détails de la Réservation
                        </h2>
                        <div className={styles.infoBox}>
                            <div className={styles.infoLine}>
                                <span className={styles.infoLabel}>ID:</span>
                                <span className={styles.infoValue}>{reservation.id}</span>
                            </div>
                            <div className={styles.infoLine}>
                                <span className={styles.infoLabel}>Service:</span>
                                <span className={styles.infoValue}>{reservation.serviceName}</span>
                            </div>
                            <div className={styles.infoLine}>
                                <span className={styles.infoLabel}>Date:</span>
                                <span className={styles.infoValue}>{formatDate(reservation.date)}</span>
                            </div>
                            <div className={styles.infoLine}>
                                <span className={styles.infoLabel}>Heure:</span>
                                <span className={styles.infoValue}>{reservation.time}</span>
                            </div>
                            <div className={styles.infoLine}>
                                <span className={styles.infoLabel}>Durée:</span>
                                <span className={styles.infoValue}>{reservation.duration} min</span>
                            </div>
                            <div className={styles.infoLine}>
                                <span className={styles.infoLabel}>Prix:</span>
                                <span className={styles.infoValue}>
                                    {reservation.price ? `${reservation.price}€` : 'N/A'}
                                </span>
                            </div>
                            <div className={styles.infoLine}>
                                <span className={styles.infoLabel}>Statut:</span>
                                <span className={`${styles.infoValue} ${styles.status}`}>
                                    {reservation.status}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Notes */}
                    {reservation.notes && (
                        <div className={styles.section}>
                            <h2>
                                <FaStickyNote className={styles.sectionIcon} />
                                Notes Spéciales
                            </h2>
                            <div className={styles.notesBox}>
                                {reservation.notes}
                            </div>
                        </div>
                    )}

                    {/* Conditions */}
                    <div className={styles.section}>
                        <h2>
                            <FaCheckCircle className={styles.sectionIcon} />
                            Conditions Importantes
                        </h2>
                        <ul className={styles.conditionsList}>
                            <li>Veuillez arriver 10 minutes avant votre rendez-vous</li>
                            <li>En cas d'annulation, préavisez au moins 24 heures avant</li>
                            <li>Les tarifs sont en euros (€)</li>
                            <li>Merci de votre confiance!</li>
                        </ul>
                    </div>
                </div>

                {/* Footer */}
                <div className={styles.footer}>
                    <p>Merci de votre confiance!</p>
                    <p>OV HAIRSTYLE - Votre salon de coiffure</p>
                    <p>Généré le: {new Date().toLocaleDateString('fr-FR')}</p>
                </div>
            </div>
        </div>
    );
}
